import { render, staticRenderFns } from "./OtherReportComponent.vue?vue&type=template&id=7fa82ae0&"
import script from "./OtherReportComponent.vue?vue&type=script&lang=js&"
export * from "./OtherReportComponent.vue?vue&type=script&lang=js&"
import style0 from "./OtherReportComponent.vue?vue&type=style&index=0&id=7fa82ae0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports